import { useEffect } from 'react'

import { UseFormReturn } from 'react-hook-form'

import { Resumes } from '@gql/graphql'

import { TResumeBuilderForm } from '@/forms/types'
import { TPublicResume } from '@/store/resumeBuilderStore'
import { serializeResumeData } from '@/utils/resume'

interface IUseResumeBuilderFormResetParams {
  form: UseFormReturn<TResumeBuilderForm>
  resume: Resumes | TPublicResume | undefined
}

export const useResumeBuilderFormReset = ({ form, resume }: IUseResumeBuilderFormResetParams) => {
  useEffect(() => {
    form.reset(
      {
        ...form.formState.defaultValues,
        ...serializeResumeData(resume),
      },
      {
        keepDefaultValues: true,
        keepDirty: true,
        keepDirtyValues: true,
      }
    )
  }, [resume])
}
